module.exports = __webpack_public_path__ + "img/bgIcon_13.ac6b9e01.png";